import { CurrencyTypeEnum } from '../../../../model/currency_type.enum';
import { Widget } from '../../widget';
import { TokenDataContent } from './token-data-content';

const TokenDataWidget = ({
  currency,
  setCurrency,
}: {
  currency: CurrencyTypeEnum;
  setCurrency?: React.Dispatch<React.SetStateAction<CurrencyTypeEnum>>;
}) => {
  return (
    <Widget cardKey={'token-data'}>
      <Widget.Content>
        <TokenDataContent currency={currency} setCurrency={setCurrency} />
      </Widget.Content>
    </Widget>
  );
};

export default TokenDataWidget;
